import React, { useState, useEffect } from "react";
import { NoFeedIcon, PrintIcon, PrintOnlineIcon } from "../../../Icons/icons.component";
import PrintAndOnlineFavouriteFeedItem from "./PrintAndOnlineFavouriteFeedItem";

export default function PrintAndOnlineFavouriteFeedList({
  entityFeeds = {},
  allArticleList,
}) {
  const [activeKey, setActiveKey] = useState("print");

  const {
    entityId,
    entityName,
    printData,
    onlineData,
    socialData,
    groupedPrintData,
    groupedOnlineData,
    type,
  } = entityFeeds;

  const printIdentifier = `print`;
  const onlineIdentifier = `online`;

  const handleCardClick = (e, id) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (id === activeKey) {
      setActiveKey(-1);
    } else {
      setActiveKey(id);
      handleOnAccordianClick(id);
    }
  };

  const handleOnAccordianClick = (id, index) => {
    setActiveKey(activeKey == id ? null : id);
    const targetElm = document.getElementById(id);
    const scrollElement = document.querySelector(".accordionListWrap");
    if (targetElm && scrollElement) {
      const position = targetElm.getBoundingClientRect().top || 0;
      setTimeout(() => {
        scrollElement.scrollTo({
          top: position - (120 - 20 * index),
          behavior: "smooth",
        });
      }, 1000);
    } else {
    }
  };

  const printFeeds = () => {
    const identifier = printIdentifier;
    const activeClass = activeKey === identifier ? "show" : "";

    if (printData && printData.length) {
      return (
        <div className={"customAccordionRow card active"}>
          <div
            className={`card-header ${activeClass}`}
            onClick={(e) => {
              handleCardClick(e, identifier);
            }}
          >
            <div className="printBadge printOnlineBadge">
              <PrintIcon />
              <span>Print</span>
            </div>
            <button
              onClick={(e) => {
                handleCardClick(e, identifier);
              }}
              id={identifier}
              type="button"
              className="btn btn-link"
            >
              &nbsp;
            </button>
          </div>
          <div className={`collapse ${activeClass}`}>
            <div className="card-body">
              <div className="inner-feed-container">
                {groupedPrintData &&
                  Object.keys(groupedPrintData).map((news, index) => {
                    if (!news) {
                      return null;
                    }
                    let singleNewsGroup = groupedPrintData[news];
                    singleNewsGroup = [...singleNewsGroup].sort(function (
                      a,
                      b
                    ) {
                      var editionA = a.edition.toUpperCase();
                      var editionB = b.edition.toUpperCase();
                      if (editionA < editionB) {
                        return -1;
                      }
                      if (editionA > editionB) {
                        return 1;
                      }
                      return 0;
                    });
                    const singleNews = singleNewsGroup && singleNewsGroup[0];
                    const editionList =
                      singleNewsGroup &&
                      singleNewsGroup.map((el) => el && el.edition);
                    return (
                      <PrintAndOnlineFavouriteFeedItem
                        key={index}
                        isPrint
                        feed={singleNews}
                        editionList={editionList}
                        allArticleList={allArticleList}
                        singleNewsGroup={singleNewsGroup}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  const onlineFeeds = () => {
    const identifier = onlineIdentifier;

    const activeClass = activeKey === identifier ? "show" : "";
    if (onlineData && onlineData.length) {
      return (
        <div
          className={
            activeKey !== identifier
              ? "customAccordionRow card"
              : "customAccordionRow card active"
          }
        >
          <div
            className={`card-header ${activeClass}`}
            onClick={(e) => {
              handleCardClick(e, identifier);
            }}
          >
            <div className="onlineBadge printOnlineBadge">
              <PrintOnlineIcon />
              <span>Online</span>
            </div>
            <button
              onClick={(e) => {
                handleCardClick(e, identifier);
              }}
              id={identifier}
              type="button"
              className="btn btn-link"
            >
              &nbsp;
            </button>
          </div>
          <div className={`collapse ${activeClass}`}>
            <div className="card-body">
              <div className="inner-feed-container">
                {groupedOnlineData &&
                  Object.keys(groupedOnlineData).map((news, index) => {
                    if (!news) {
                      return null;
                    }
                    let singleNewsGroup = groupedOnlineData[news];
                    const singleNews = singleNewsGroup && singleNewsGroup[0];
                    const editionList =
                      singleNewsGroup &&
                      singleNewsGroup.map((el) => el && el.edition);
                    return (
                      <PrintAndOnlineFavouriteFeedItem
                        key={index}
                        isOnline
                        feed={singleNews}
                        editionList={editionList}
                        allArticleList={allArticleList}
                        singleNewsGroup={singleNewsGroup}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <div className="accordion accordionListWrap socialAccordionWrap favFeedsAccordionWrap favPrintOnlineFeeds">
        {printFeeds()}
        {onlineFeeds()}
      </div>
    </>
  );
}
